import styled, { css } from 'styled-components';
import { WCS } from '../../../../../components/ui/calendar/calendar-week/week-utils';

export const MenuHeaderSC = styled.div<{
  horizontalPosition?: 'left' | 'right';
}>`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
  margin-bottom: 10px;

  .title {
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 24px;
    line-height: 24px;

    border: none;
    outline: none;
    background: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .actions {
    position: absolute;
    top: -25px;
    right: -20px;
    padding-left: 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    .action {
      border: none;
      outline: none;
      background: none;
      cursor: pointer;
      padding: 0;
      margin-left: 15px;

      &:hover {
        opacity: 0.5;
      }

      button {
        padding: 0;
      }

      svg {
        width: 15px;
        height: 15px;
      }
    }
  }

  ${({ horizontalPosition }) => {
    return css`
      &::before {
        content: '';
        width: 12px;
        height: 12px;
        position: absolute;
        transform: rotate(-45deg);
        background: white;
        z-index: 1;
        ${() => {
          if (horizontalPosition === 'right') {
            return css`
              left: -45px;
              top: -15px;
            `;
          } else {
            return css`
              left: ${WCS.menuWidthCalendarView - 45}px;
              top: -15px;
            `;
          }
        }};
      }
    `;
  }};
`;
